module.exports = __webpack_public_path__ + "img/avatar7.04fa76b1.png";